// ── EMPLOYER CONFIG ────────────────────────────────────────────────────────
export const employer = {
  employerUniqueId: "EMP-00127-ACME",
  clientId: "ACM-2024-001",
  companyName: "Acme Restaurant Group LLC",
  ein: "47-1234567",
  payPeriodStart: "2026-04-01",
  payPeriodEnd: "2026-04-15",
  isDirectDepositEnabled: true,
  processingMode: "LIVE",
  lastRunId: "EMP-00127-ACME_20260415_143022Z",
};

export const earningCodes = [
  { code: "1", description: "Regular Hours", calcMethod: "H", rate: null },
  { code: "2", description: "Overtime", calcMethod: "H", multiplier: 1.5, rate: null },
  { code: "5", description: "Vacation Pay", calcMethod: "H", rate: null },
  { code: "7", description: "Holiday Pay", calcMethod: "Z", rate: null },
  { code: "23", description: "Salary", calcMethod: "S", rate: null },
  { code: "30", description: "Commission", calcMethod: "Z", rate: null },
  { code: "81", description: "Tips Reported", calcMethod: "Z", rate: null },
  { code: "90", description: "Bonus", calcMethod: "Z", rate: null },
];

export const deductionCodes = [
  { code: "D01", description: "401(k) Employee", calcMethod: "A", rate: 0.06 },
  { code: "D02", description: "Health Insurance", calcMethod: "Z", amount: 125.00 },
  { code: "D03", description: "Garnishment", calcMethod: "G", rate: 0.25 },
  { code: "D04", description: "Dental Insurance", calcMethod: "Z", amount: 18.50 },
  { code: "D05", description: "Vision Insurance", calcMethod: "Z", amount: 6.75 },
  { code: "D06", description: "Roth 401(k)", calcMethod: "A", rate: 0.03 },
];

export const taxCodes = [
  { code: "FIT", description: "Federal Income Tax", jurisdiction: "Federal" },
  { code: "FICA-SS", description: "Social Security", jurisdiction: "Federal" },
  { code: "FICA-MED", description: "Medicare", jurisdiction: "Federal" },
  { code: "NY-SIT", description: "New York State Income Tax", jurisdiction: "State" },
  { code: "NY-SDI", description: "NY State Disability Insurance", jurisdiction: "State" },
  { code: "NYC-PIT", description: "New York City Personal Income Tax", jurisdiction: "Local" },
];

export const departments = [
  { id: "DEPT-001", name: "Front of House" },
  { id: "DEPT-002", name: "Back of House" },
  { id: "DEPT-003", name: "Management" },
  { id: "DEPT-004", name: "Catering & Events" },
];

// ── EMPLOYEES ───────────────────────────────────────────────────────────────
export const employees = [
  {
    employeeUniqueId: "EE-A1B2C3D4",
    firstName: "Maria",
    lastName: "Santos",
    employeeNumber: "EE-0001",
    classificationCode: "E",
    payBasisCode: "H",
    payRate1: 18.50,
    departmentId: "DEPT-001",
    department: "Front of House",
    employmentStatusCode: "A",
    isDirectDepositEnabled: true,
    activeEarnings: ["1", "2", "5", "81"],
    activeDeductions: ["D01", "D02", "D04"],
  },
  {
    employeeUniqueId: "EE-B2C3D4E5",
    firstName: "James",
    lastName: "Okafor",
    employeeNumber: "EE-0002",
    classificationCode: "E",
    payBasisCode: "H",
    payRate1: 22.00,
    departmentId: "DEPT-002",
    department: "Back of House",
    employmentStatusCode: "A",
    isDirectDepositEnabled: true,
    activeEarnings: ["1", "2", "7"],
    activeDeductions: ["D01", "D02"],
  },
  {
    employeeUniqueId: "EE-C3D4E5F6",
    firstName: "Priya",
    lastName: "Menon",
    employeeNumber: "EE-0003",
    classificationCode: "E",
    payBasisCode: "S",
    payRate1: 1650.00,
    departmentId: "DEPT-003",
    department: "Management",
    employmentStatusCode: "A",
    isDirectDepositEnabled: true,
    activeEarnings: ["23"],
    activeDeductions: ["D01", "D06", "D02", "D04", "D05"],
  },
  {
    employeeUniqueId: "EE-D4E5F6G7",
    firstName: "Tom",
    lastName: "Grayson",
    employeeNumber: "EE-0004",
    classificationCode: "E",
    payBasisCode: "H",
    payRate1: 19.25,
    departmentId: "DEPT-001",
    department: "Front of House",
    employmentStatusCode: "A",
    isDirectDepositEnabled: false,
    activeEarnings: ["1", "5", "81"],
    activeDeductions: ["D02"],
  },
  {
    employeeUniqueId: "EE-E5F6G7H8",
    firstName: "Yuki",
    lastName: "Tanaka",
    employeeNumber: "EE-0005",
    classificationCode: "E",
    payBasisCode: "H",
    payRate1: 21.00,
    departmentId: "DEPT-002",
    department: "Back of House",
    employmentStatusCode: "A",
    isDirectDepositEnabled: true,
    activeEarnings: ["1", "2"],
    activeDeductions: ["D01", "D02", "D05"],
  },
  {
    employeeUniqueId: "GUID_REQUIRED",
    firstName: "Carlos",
    lastName: "Vega",
    employeeNumber: "EE-0006",
    classificationCode: "E",
    payBasisCode: "H",
    payRate1: 17.75,
    departmentId: "DEPT-004",
    department: "Catering & Events",
    employmentStatusCode: "A",
    isDirectDepositEnabled: true,
    activeEarnings: ["1", "2", "30"],
    activeDeductions: ["D01"],
  },
  {
    employeeUniqueId: "EE-G7H8I9J0",
    firstName: "Lisa",
    lastName: "Park",
    employeeNumber: "EE-0007",
    classificationCode: "I",
    payBasisCode: "Z",
    payRate1: 0,
    departmentId: "DEPT-004",
    department: "Catering & Events",
    employmentStatusCode: "A",
    isDirectDepositEnabled: false,
    activeEarnings: ["30", "90"],
    activeDeductions: [],
  },
  {
    employeeUniqueId: "EE-H8I9J0K1",
    firstName: "Darnell",
    lastName: "Harris",
    employeeNumber: "EE-0008",
    classificationCode: "E",
    payBasisCode: "H",
    payRate1: 20.50,
    departmentId: "DEPT-001",
    department: "Front of House",
    employmentStatusCode: "A",
    isDirectDepositEnabled: true,
    activeEarnings: ["1", "2", "81"],
    activeDeductions: ["D01", "D02", "D03"],
  },
];

// ── WORKBOOK EARNINGS ───────────────────────────────────────────────────────
export const earningsWorkbook = [
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", earningCode: "1", description: "Regular Hours", calcMethod: "H", hours: 72, rate: 18.50, amount: 1332.00, multiplier: 1.0, rowStamp: "RS-20260401-A1", status: "OK" },
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", earningCode: "2", description: "Overtime", calcMethod: "H", hours: 6, rate: 18.50, amount: 166.50, multiplier: 1.5, rowStamp: "RS-20260401-A2", status: "OK" },
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", earningCode: "81", description: "Tips Reported", calcMethod: "Z", hours: 0, rate: 0, amount: 480.00, multiplier: 1.0, rowStamp: "RS-20260401-A3", status: "OK" },
  { employeeUniqueId: "EE-B2C3D4E5", name: "James Okafor", earningCode: "1", description: "Regular Hours", calcMethod: "H", hours: 80, rate: 22.00, amount: 1760.00, multiplier: 1.0, rowStamp: "RS-20260401-B1", status: "OK" },
  { employeeUniqueId: "EE-B2C3D4E5", name: "James Okafor", earningCode: "2", description: "Overtime", calcMethod: "H", hours: 4, rate: 22.00, amount: 132.00, multiplier: 1.5, rowStamp: "RS-20260401-B2", status: "OK" },
  { employeeUniqueId: "EE-C3D4E5F6", name: "Priya Menon", earningCode: "23", description: "Salary", calcMethod: "S", hours: 0, rate: 0, amount: 1650.00, multiplier: 1.0, rowStamp: "RS-20260401-C1", status: "OK" },
  { employeeUniqueId: "EE-D4E5F6G7", name: "Tom Grayson", earningCode: "1", description: "Regular Hours", calcMethod: "H", hours: 68, rate: 19.25, amount: 1309.00, multiplier: 1.0, rowStamp: "RS-20260401-D1", status: "OK" },
  { employeeUniqueId: "EE-D4E5F6G7", name: "Tom Grayson", earningCode: "81", description: "Tips Reported", calcMethod: "Z", hours: 0, rate: 0, amount: 540.00, multiplier: 1.0, rowStamp: "RS-20260401-D2", status: "OK" },
  { employeeUniqueId: "EE-E5F6G7H8", name: "Yuki Tanaka", earningCode: "1", description: "Regular Hours", calcMethod: "H", hours: 80, rate: 21.00, amount: 1680.00, multiplier: 1.0, rowStamp: "RS-20260401-E1", status: "OK" },
  { employeeUniqueId: "EE-E5F6G7H8", name: "Yuki Tanaka", earningCode: "2", description: "Overtime", calcMethod: "H", hours: 8, rate: 21.00, amount: 252.00, multiplier: 1.5, rowStamp: "RS-20260401-E2", status: "OK" },
  { employeeUniqueId: "GUID_REQUIRED", name: "Carlos Vega", earningCode: "1", description: "Regular Hours", calcMethod: "H", hours: 76, rate: 17.75, amount: 1349.00, multiplier: 1.0, rowStamp: "REQUIRES_GET_BEFORE_PUT", status: "CRITICAL" },
  { employeeUniqueId: "GUID_REQUIRED", name: "Carlos Vega", earningCode: "30", description: "Commission", calcMethod: "Z", hours: 0, rate: 0, amount: 320.00, multiplier: 1.0, rowStamp: "REQUIRES_GET_BEFORE_PUT", status: "CRITICAL" },
  { employeeUniqueId: "EE-G7H8I9J0", name: "Lisa Park", earningCode: "30", description: "Commission", calcMethod: "Z", hours: 0, rate: 0, amount: 2400.00, multiplier: 1.0, rowStamp: "RS-20260401-G1", status: "OK" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", earningCode: "1", description: "Regular Hours", calcMethod: "H", hours: 75, rate: 20.50, amount: 1537.50, multiplier: 1.0, rowStamp: "RS-20260401-H1", status: "OK" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", earningCode: "2", description: "Overtime", calcMethod: "H", hours: 5, rate: 20.50, amount: 153.75, multiplier: 1.5, rowStamp: "RS-20260401-H2", status: "OK" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", earningCode: "81", description: "Tips Reported", calcMethod: "Z", hours: 0, rate: 0, amount: 390.00, multiplier: 1.0, rowStamp: "RS-20260401-H3", status: "OK" },
];

// ── WORKBOOK DEDUCTIONS ─────────────────────────────────────────────────────
export const deductionsWorkbook = [
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", deductionCode: "D01", description: "401(k)", calcMethod: "A", rate: 0.06, amount: 89.91, rowStamp: "RS-20260401-A-D01", status: "OK" },
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", deductionCode: "D02", description: "Health Insurance", calcMethod: "Z", rate: 0, amount: 125.00, rowStamp: "RS-20260401-A-D02", status: "OK" },
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", deductionCode: "D04", description: "Dental Insurance", calcMethod: "Z", rate: 0, amount: 18.50, rowStamp: "RS-20260401-A-D04", status: "OK" },
  { employeeUniqueId: "EE-B2C3D4E5", name: "James Okafor", deductionCode: "D01", description: "401(k)", calcMethod: "A", rate: 0.06, amount: 113.52, rowStamp: "RS-20260401-B-D01", status: "OK" },
  { employeeUniqueId: "EE-B2C3D4E5", name: "James Okafor", deductionCode: "D02", description: "Health Insurance", calcMethod: "Z", rate: 0, amount: 125.00, rowStamp: "RS-20260401-B-D02", status: "OK" },
  { employeeUniqueId: "EE-C3D4E5F6", name: "Priya Menon", deductionCode: "D01", description: "401(k)", calcMethod: "A", rate: 0.06, amount: 99.00, rowStamp: "RS-20260401-C-D01", status: "OK" },
  { employeeUniqueId: "EE-C3D4E5F6", name: "Priya Menon", deductionCode: "D06", description: "Roth 401(k)", calcMethod: "A", rate: 0.03, amount: 49.50, rowStamp: "RS-20260401-C-D06", status: "OK" },
  { employeeUniqueId: "EE-C3D4E5F6", name: "Priya Menon", deductionCode: "D02", description: "Health Insurance", calcMethod: "Z", rate: 0, amount: 125.00, rowStamp: "RS-20260401-C-D02", status: "OK" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", deductionCode: "D03", description: "Garnishment", calcMethod: "G", rate: 0.25, amount: 520.31, rowStamp: "RS-20260401-H-D03", status: "HIGH" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", deductionCode: "D01", description: "401(k)", calcMethod: "A", rate: 0.06, amount: 124.88, rowStamp: "RS-20260401-H-D01", status: "OK" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", deductionCode: "D02", description: "Health Insurance", calcMethod: "Z", rate: 0, amount: 125.00, rowStamp: "RS-20260401-H-D02", status: "OK" },
];

// ── VALIDATION FLAGS ────────────────────────────────────────────────────────
export const validationFlags = [
  {
    id: "FLAG-001",
    ruleId: "VAL-03",
    severity: "CRITICAL",
    employee: "Carlos Vega (EE-0006)",
    message: "GUID_REQUIRED placeholder found in EmployeeUniqueId — unresolved new hire GUID.",
    resolution: "Fetch EmployeeUniqueId via GET /api/v1/employees?clientId=ACM-2024-001 and re-run Extractor V3.",
    blocksLoad: true,
  },
  {
    id: "FLAG-002",
    ruleId: "VAL-03",
    severity: "CRITICAL",
    employee: "Carlos Vega (EE-0006)",
    message: "REQUIRES_GET_BEFORE_PUT in RowStamp field — cannot PUT without current RowStamp.",
    resolution: "Retrieve current RowStamp via GET /api/v1/employee/{employeeUniqueId}/Earnings before retrying PUT.",
    blocksLoad: true,
  },
  {
    id: "FLAG-003",
    ruleId: "VAL-02",
    severity: "CRITICAL",
    employee: "Batch Total",
    message: "Gross earnings total $16,955.75 does not match source document total $17,012.00 — variance $56.25 exceeds $0.02 threshold.",
    resolution: "Re-examine source EML and CSV files for Maria Santos holiday pay row omitted during parse.",
    blocksLoad: true,
  },
  {
    id: "FLAG-004",
    ruleId: "VAL-08",
    severity: "HIGH",
    employee: "Darnell Harris (EE-0008)",
    message: "Garnishment deduction D03 amount $520.31 does not match 25% of disposable earnings within $0.01.",
    resolution: "Verify disposable earnings calculation per CCPA garnishment limits before approving load.",
    blocksLoad: false,
  },
  {
    id: "FLAG-005",
    ruleId: "VAL-07",
    severity: "HIGH",
    employee: "James Okafor (EE-0002)",
    message: "OT row multiplier 1.5 confirmed, but OT hours (4h) exceed scheduled cap (0h) — no OT authorization on file.",
    resolution: "Confirm manager-approved OT authorization for James Okafor pay period 04/01–04/15.",
    blocksLoad: false,
  },
  {
    id: "FLAG-006",
    ruleId: "VAL-06",
    severity: "MEDIUM",
    employee: "Tom Grayson (EE-0004)",
    message: "No direct deposit on file — paper check will be issued. Confirm mailing address is current.",
    resolution: "Verify mailing address in PrimePay employee profile or enroll in direct deposit.",
    blocksLoad: false,
  },
  {
    id: "FLAG-007",
    ruleId: "INFO",
    severity: "INFO",
    employee: "Lisa Park (EE-0007)",
    message: "1099 Independent Contractor. No direct deposit and no deduction elections — correct per classification.",
    resolution: "No action required.",
    blocksLoad: false,
  },
  {
    id: "FLAG-008",
    ruleId: "INFO",
    severity: "INFO",
    employee: "Priya Menon (EE-0003)",
    message: "Dual 401(k) elections (D01 + D06) total 9% — below IRS annual limit. No action needed.",
    resolution: "No action required.",
    blocksLoad: false,
  },
];

// ── LOAD RESULTS ────────────────────────────────────────────────────────────
export const loadResults = [
  { employeeUniqueId: "EE-A1B2C3D4", name: "Maria Santos", earningsRows: 3, deductionsRows: 3, earningsStatus: "LOADED", deductionsStatus: "LOADED", httpStatus: 200, timestamp: "2026-04-15T14:32:11Z" },
  { employeeUniqueId: "EE-B2C3D4E5", name: "James Okafor", earningsRows: 2, deductionsRows: 2, earningsStatus: "LOADED", deductionsStatus: "LOADED", httpStatus: 200, timestamp: "2026-04-15T14:32:18Z" },
  { employeeUniqueId: "EE-C3D4E5F6", name: "Priya Menon", earningsRows: 1, deductionsRows: 3, earningsStatus: "LOADED", deductionsStatus: "LOADED", httpStatus: 200, timestamp: "2026-04-15T14:32:24Z" },
  { employeeUniqueId: "EE-D4E5F6G7", name: "Tom Grayson", earningsRows: 2, deductionsRows: 1, earningsStatus: "LOADED", deductionsStatus: "LOADED", httpStatus: 200, timestamp: "2026-04-15T14:32:30Z" },
  { employeeUniqueId: "EE-E5F6G7H8", name: "Yuki Tanaka", earningsRows: 2, deductionsRows: 2, earningsStatus: "LOADED", deductionsStatus: "LOADED", httpStatus: 200, timestamp: "2026-04-15T14:32:37Z" },
  { employeeUniqueId: "GUID_REQUIRED", name: "Carlos Vega", earningsRows: 2, deductionsRows: 1, earningsStatus: "BLOCKED", deductionsStatus: "BLOCKED", httpStatus: null, timestamp: null },
  { employeeUniqueId: "EE-G7H8I9J0", name: "Lisa Park", earningsRows: 1, deductionsRows: 0, earningsStatus: "LOADED", deductionsStatus: "SKIPPED", httpStatus: 200, timestamp: "2026-04-15T14:32:44Z" },
  { employeeUniqueId: "EE-H8I9J0K1", name: "Darnell Harris", earningsRows: 3, deductionsRows: 3, earningsStatus: "LOADED", deductionsStatus: "LOADED", httpStatus: 200, timestamp: "2026-04-15T14:32:51Z" },
];

// ── PIPELINE RUNS HISTORY ───────────────────────────────────────────────────
export const pipelineHistory = [
  { runId: "EMP-00127-ACME_20260415_143022Z", date: "Apr 15, 2026 14:30", payPeriod: "04/01 – 04/15", status: "BLOCKED", criticalFlags: 3, loaded: 7, blocked: 1 },
  { runId: "EMP-00127-ACME_20260401_091244Z", date: "Apr 01, 2026 09:12", payPeriod: "03/16 – 03/31", status: "SUCCESS", criticalFlags: 0, loaded: 8, blocked: 0 },
  { runId: "EMP-00127-ACME_20260316_083511Z", date: "Mar 16, 2026 08:35", payPeriod: "03/01 – 03/15", status: "SUCCESS", criticalFlags: 0, loaded: 8, blocked: 0 },
  { runId: "EMP-00127-ACME_20260301_104433Z", date: "Mar 01, 2026 10:44", payPeriod: "02/16 – 02/28", status: "WARNING", criticalFlags: 0, loaded: 8, blocked: 0 },
];

// ── AUDIT LOG ───────────────────────────────────────────────────────────────
export const auditLog = [
  { ts: "14:30:01Z", step: "AUTH", action: "GET /auth/salt/{RequestUser}", status: 200, note: "Salt fetched OK" },
  { ts: "14:30:02Z", step: "AUTH", action: "SHA1 password hash + SHA256 RequestHash computed", status: null, note: "Headers signed" },
  { ts: "14:30:03Z", step: "STEP 1", action: "GET /api/v1/employer/Earnings", status: 200, note: "8 earning codes" },
  { ts: "14:30:04Z", step: "STEP 1", action: "GET /api/v1/employer/deductions", status: 200, note: "6 deduction codes" },
  { ts: "14:30:05Z", step: "STEP 1", action: "GET /api/v1/employer/taxes", status: 200, note: "6 tax codes" },
  { ts: "14:30:06Z", step: "STEP 1", action: "GET /api/v1/employer/clientprofile", status: 200, note: "isDirectDepositEnabled: true" },
  { ts: "14:30:07Z", step: "STEP 1", action: "GET /api/v1/employer/departments", status: 200, note: "4 departments" },
  { ts: "14:30:08Z", step: "STEP 1", action: "GET /api/v1/employees", status: 200, note: "8 employees returned" },
  { ts: "14:30:10Z", step: "STEP 2", action: "GET /api/v1/employees/EE-A1B2C3D4", status: 200, note: "Maria Santos profile OK" },
  { ts: "14:30:11Z", step: "STEP 2", action: "GET /api/v1/employees/EE-B2C3D4E5", status: 200, note: "James Okafor profile OK" },
  { ts: "14:30:12Z", step: "STEP 2", action: "GET /api/v1/employees/EE-C3D4E5F6", status: 200, note: "Priya Menon profile OK" },
  { ts: "14:30:13Z", step: "STEP 2", action: "GET /api/v1/employees/EE-D4E5F6G7", status: 200, note: "Tom Grayson profile OK" },
  { ts: "14:30:14Z", step: "STEP 2", action: "GET /api/v1/employees/EE-E5F6G7H8", status: 200, note: "Yuki Tanaka profile OK" },
  { ts: "14:30:15Z", step: "STEP 2", action: "GET /api/v1/employees/GUID_REQUIRED", status: 404, note: "WARN: New hire GUID not in system" },
  { ts: "14:30:16Z", step: "STEP 2", action: "GET /api/v1/employees/EE-G7H8I9J0", status: 200, note: "Lisa Park profile OK" },
  { ts: "14:30:17Z", step: "STEP 2", action: "GET /api/v1/employees/EE-H8I9J0K1", status: 200, note: "Darnell Harris profile OK" },
  { ts: "14:30:45Z", step: "STEP 3", action: "Claude Extractor V3 Skill invoked", status: null, note: "Parsing 3 source files (EML, CSV, XLSX)" },
  { ts: "14:31:22Z", step: "STEP 3", action: "Workbook output: ACM-2024-001_PrimePay_Enhanced_Workbook_v8_POPULATED.xlsx", status: null, note: "16 earning rows, 11 deduction rows" },
  { ts: "14:31:23Z", step: "STEP 4", action: "XLSX → JSON conversion", status: null, note: "earnings_payload.json + deductions_payload.json generated" },
  { ts: "14:31:24Z", step: "STEP 5", action: "Validation layer run", status: null, note: "3 CRITICAL, 2 HIGH, 1 MEDIUM, 2 INFO" },
  { ts: "14:32:11Z", step: "STEP 6", action: "PUT /api/v1/employee/EE-A1B2C3D4/Earnings", status: 200, note: "3 earning rows loaded" },
  { ts: "14:32:13Z", step: "STEP 6", action: "PUT /api/v1/employee/EE-A1B2C3D4/deductions", status: 200, note: "3 deduction rows loaded" },
  { ts: "14:32:18Z", step: "STEP 6", action: "PUT /api/v1/employee/EE-B2C3D4E5/Earnings", status: 200, note: "2 earning rows loaded" },
  { ts: "14:32:20Z", step: "STEP 6", action: "PUT /api/v1/employee/EE-B2C3D4E5/deductions", status: 200, note: "2 deduction rows loaded" },
  { ts: "14:32:51Z", step: "STEP 6", action: "PUT /api/v1/employee/EE-H8I9J0K1/deductions", status: 200, note: "3 deduction rows loaded" },
  { ts: "14:32:52Z", step: "STEP 6", action: "BLOCKED: Carlos Vega skipped — GUID_REQUIRED unresolved", status: null, note: "2 earnings + 1 deduction rows blocked" },
  { ts: "14:32:53Z", step: "RECONCILE", action: "Reconciliation complete", status: null, note: "7/8 employees loaded. 1 blocked. Open actions required." },
];
